// ============================================================
// useCollabUser.ts
// Maps the authenticated user to the CollabUser identity the collab editor
// shows to OTHER editors as their avatar caret. Extracted so every collab
// RichTextEditor (client notes + the case rich-text fields) builds the same
// identity the same way — mirrors the inline mapping first written for client
// notes in ClientSearchView.
// ============================================================
import { useCasevoStore } from '../store/useCasevoStore'
import type { CollabUser } from '../components/shared/RichTextEditor'

export const useCollabUser = (): CollabUser | undefined => {
  const authUser = useCasevoStore((s) => s.authUser)
  if (!authUser) return undefined
  return {
    id: authUser.id,
    name: `${authUser.firstName} ${authUser.lastName}`.trim() || authUser.email,
    color: authUser.avatarColour || '#6b7280',
    initials:
      `${authUser.firstName?.[0] ?? ''}${authUser.lastName?.[0] ?? ''}`.toUpperCase() ||
      (authUser.email?.[0] ?? '?').toUpperCase(),
    avatarPhotoUrl: authUser.avatarPhotoUrl,
  }
}
